import axios from "axios";
import { ApiURI } from "../types/configs";
import { headers } from "./headers";
import { Log } from "../models/Log";

export const UsersInstance = axios.create({
  baseURL: ApiURI + "audit",
});

export const fetchAudit = async (
  date: Date,
  page: number,
  size: number = 10
): Promise<Log[][]> => {
  const response = await UsersInstance.get<Log[][]>(
    `/day/grouped?date=${date.toISOString()}&pageNumber=${page}&pageSize=${size}`,
    headers()
  );
  return response.data;
};

export const fetchAuditForResource = async (
  resourceId: string,
  count: number = 10
): Promise<Log[]> => {
  const response = await UsersInstance.get<Log[]>(
    `/${resourceId}?count=${count}`,
    headers()
  );
  return response.data;
};

export const fetchAuditByCorrelation = async (
  correlationId: string
): Promise<Log[]> => {
  const response = await UsersInstance.get<Log[]>(
    `/correlation/${correlationId}`,
    headers()
  );
  return response.data;
};
